import React from 'react'
import * as Yup from 'yup'
import { Field, Formik, Form } from 'formik'
import { get } from 'lodash'
import styled from 'styled-components'
import { Text, Row, Column, FormikInput, Button, FlexContainer } from '../src/components/common'
import withAWSAuth from '../src/hoc/withAWSAuth'
import AuthWrapper, { RequestErrorWrapper } from '../src/components/layouts/Auth/Auth.wrapper'
import ConfirmUsernamePage from '../src/components/sections/Auth/update-password'
import Link from '../src/components/routes/Link';

const ValidationSchema = Yup.object().shape({
  code: Yup.string()
    .required('form.validations.required'),
  username: Yup.string()
    .email('form.validations.email')
    .required('form.validations.required')
})

const FormContainer = styled(FlexContainer)``

const LoginDisplayForm = ({ errors, dirty, isSubmitting, handleSubmit, handleChange, handleReset, submitCount, isValid, ...props }) => (
  (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <FormContainer direction='column'>
        <Row>
          <Column justify='flex-end'>
            <Text text='Confirmar Email' style={{ fontSize: '1.25rem', color: '#333333' }} />
          </Column>
        </Row>
        <Row>
          <Column>
            <Field
              style={{ padding: 0 }}
              component={FormikInput}
              name='username'
              type='input'
              label='Usuario'
              hasFeedback
              placeholder='Usuario'
              disabled={isSubmitting}
              allowClear
              submitCount={submitCount}
            />
          </Column>
        </Row>

        <Row>
          <Column>
            <Field
              style={{ padding: 0 }}
              component={FormikInput}
              name='code'
              type='password'
              label='Code'
              placeholder='Code'
              hasFeedback
              allowClear
              disabled={isSubmitting}
              submitCount={submitCount}
            />
          </Column>
        </Row>
        {errors && errors['response'] && <Row>
          <Column>
            <RequestErrorWrapper>
              <Text text={errors['response']} />
            </RequestErrorWrapper>
          </Column>
        </Row>}
        <Row style={{ margin: '15px 0px' }}>
          <Column>
            <Button type='submit' className='login-form-button' disabled={isSubmitting || !isValid} loading={isSubmitting}>
                Iniciar Sesión
            </Button>
          </Column>
        </Row>
        <Row>
          <Column justify='center' style={{ }}>
            <Link style={{ textAlign: 'center' }} href='/forgot-password'>Olvide contraseña</Link>
          </Column>
          <Column justify='center'>
            <Link style={{ textAlign: 'center' }} href='/forgot-password'>Ayuda</Link>
          </Column>
        </Row>
      </FormContainer >
    </Form>
  )
)
const LoginForm = ({ handleSubmit, handleReset, initialValues, isSubmitting }) => (
  <Formik
    onSubmit={handleSubmit}
    onReset={handleReset}
    initialValues={initialValues}
    validationSchema={ValidationSchema}
    render={LoginDisplayForm}
  />
)

class Login extends React.Component {
  state = { firstLogin: false, credentials: {} }
  handleSubmit = (values, { setSubmitting, setFieldError }) => {
    const { awsAuth } = this.props
    setSubmitting(true)
    awsAuth.validateSignupCode(values)
      .then((response) => {
        if (get(response, 'status', {}) === 'NEW_PASSWORD_REQUIRED') {
          return this.setState({ credentials: values, firstLogin: true })
        }
        setSubmitting(false)
        // return window.location.reload()
      })
      .catch((err) => {
        const errorCode = get(err, 'code')
        console.log(err)
        setFieldError('response', `form.auth.error.${errorCode}`)
        setSubmitting(false)
      })
  }
  render () {
    const { credentials, firstLogin } = this.state
    if (firstLogin) {
      return <ConfirmUsernamePage credentials={credentials} />
    }
    return (
      <AuthWrapper>
        <LoginForm handleSubmit={this.handleSubmit} initialValues={{ username: '', password: '' }} />
      </AuthWrapper>
    )
  }
}
export default withAWSAuth(Login);
